/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop, State, Listen } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { EfbArticleSectionData } from './article-section.types';

@Component({
  tag: 'efb-article-section',
  styleUrl: 'article-section.scss',
  shadow: true,
})
export class EfbProductSection {
  /**
   * State
   */

  @State() isArticleModalOpen: boolean = false;

  @State() modalActiveItem: string;

  /**
   * Props
   */

  @Prop() data: EfbArticleSectionData | string;

  @Memoize('data')
  get parsedData(): EfbArticleSectionData {
    return parseIfString(this.data);
  }

  /**
   * Events
   */

  @Listen('efbClickAction')
  onEfbClickActionHandler(e: CustomEvent) {
    const { name, value } = e.detail;

    if (name === 'open-article-modal') {
      this.isArticleModalOpen = true;

      this.modalActiveItem = value;
    }
  }

  @Listen('closeModal')
  closeModalHandler(e: CustomEvent) {
    const { modalId } = e.detail;

    if (modalId === 'article-modal') {
      this.isArticleModalOpen = false;
    }
  }

  /**
   * Render
   */

  render() {
    const data = this.parsedData;

    return (
      <Host>
        <div class="article-section">
          <div class="container">
            {/* Head */}
            <div class="head">
              <efb-title tag="h2" text={data.heading} size="sm" bottomMargin="md" bold />
              <efb-paragraph
                style={{ maxWidth: '483px' }}
                text={data.text}
                size="md"
                bottomMargin="lg"
              />
            </div>

            {/* Slider */}
            <div class="body">
              <efb-article-slider data={JSON.stringify(this.parsedData.slider)} />
            </div>
          </div>

          {/* Modal */}
          {this.isArticleModalOpen && (
            <efb-article-modal
              data={JSON.stringify(this.parsedData.modal)}
              activeItem={this.modalActiveItem}
            ></efb-article-modal>
          )}
        </div>
      </Host>
    );
  }
}
